module.exports = __webpack_public_path__ + "static/media/rehabilitation.3f30022d.svg";